import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center min-width-0" }
const _hoisted_2 = { class: "flex-fill text-truncate pl-2" }

import {computed, ModelRef} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import OperatorSelectTag
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/attachedOperatorsSelect/OperatorSelectTag.vue";
import OperatorMessageSetDialogStatusAssignedOpenApiModel = OperatorApplicationApi.OperatorMessageSetDialogStatusAssignedOpenApiModel;



const __default__ = {
    name: "DialogAssigneeSelect"
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    placeholder: { default: () => (__("Не выбраны")) },
    filterable: { type: Boolean, default: true },
    disabled: { type: Boolean }
  }, {
    "modelValue": {
    default: () => ({
        operatorLogins: [],
        groupIds: []
    })
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let assignedModel: ModelRef<OperatorMessageSetDialogStatusAssignedOpenApiModel> = _useModel<OperatorMessageSetDialogStatusAssignedOpenApiModel>(__props, "modelValue");


let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.userdata.siteId];
});

let groups = computed(() => {
    return site.value?.groups ?? [];
});

let operators = computed(() => {
    return site.value ? OperatorAccountStore.getOperatorsOfSite(site.value) : [];
});

let selectValue = computed(() => {
    return [...assignedModel.value.groupIds, ...assignedModel.value.operatorLogins];
});

function onSelectInput(value: string[]) {
    let model: OperatorMessageSetDialogStatusAssignedOpenApiModel = {
        groupIds: [],
        operatorLogins: []
    };
    for (let item of value) {
        if (groups.value.find(group => group.id === item)) {
            model.groupIds.push(item);
        } else if (operators.value.find(operator => operator.login === item)) {
            model.operatorLogins.push(item);
        }
    }
    assignedModel.value = model;
}

function removeGroupId(groupId: string) {
    if (!props.disabled) {
        toggleArrayElement(assignedModel.value.groupIds, groupId, false);
        onSelectInput(selectValue.value);
    }
}

function removeOperatorLogin(login: string) {
    if (!props.disabled) {
        toggleArrayElement(assignedModel.value.operatorLogins, login, false);
        onSelectInput(selectValue.value);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    class: "w-100",
    "model-value": [..._unref(selectValue)],
    placeholder: __props.placeholder,
    "onUpdate:modelValue": onSelectInput,
    multiple: "",
    disabled: __props.disabled,
    clearable: "",
    filterable: __props.filterable
  }, {
    tag: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.groupIds, (groupId) => {
        return (_openBlock(), _createBlock(OperatorSelectTag, {
          descr: _unref(groups).find(group => group.id === groupId)?.descr ?? _unref(__)('Удалённый отдел'),
          icon: "users",
          closable: "",
          onClose: ($event: any) => (removeGroupId(groupId))
        }, null, 8, ["descr", "onClose"]))
      }), 256)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.operatorLogins, (login) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_unref(OperatorAccountStore).operatorsDictionary.value[login])
            ? (_openBlock(), _createBlock(OperatorSelectTag, {
                key: 0,
                operator: _unref(OperatorAccountStore).operatorsDictionary.value[login],
                closable: "",
                onClose: ($event: any) => (removeOperatorLogin(login))
              }, null, 8, ["operator", "onClose"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    default: _withCtx(() => [
      (_unref(groups).length)
        ? (_openBlock(), _createBlock(_component_el_option_group, {
            key: 0,
            label: _unref(__)('Отделы операторов')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: group.descr,
                  value: group.id
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      (_unref(operators).length)
        ? (_openBlock(), _createBlock(_component_el_option_group, {
            key: 1,
            label: _unref(__)('Операторы')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  value: operator.login,
                  label: _unref(getOperatorDisplayName)(operator)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(CoreUiOperatorAvatar, {
                        operator: operator,
                        size: "2em"
                      }, null, 8, ["operator"]),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getOperatorDisplayName)(operator)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "placeholder", "disabled", "filterable"]))
}
}

})